import { render } from "./HexagonButton.vue?vue&type=template&id=746e53dc&scoped=true"
import script from "./HexagonButton.vue?vue&type=script&lang=js"
export * from "./HexagonButton.vue?vue&type=script&lang=js"

import "./HexagonButton.vue?vue&type=style&index=0&id=746e53dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746e53dc"]])

export default __exports__